import type { SVGProps } from 'react';

export const Filter = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.025 17.5a.798.798 0 0 1-.55-.2.798.798 0 0 1-.2-.55.71.71 0 0 1 .2-.525.748.748 0 0 1 .55-.225h1.925c.217 0 .392.075.525.225.15.133.225.308.225.525 0 .217-.075.4-.225.55a.71.71 0 0 1-.525.2h-1.925ZM7.15 12.75a.799.799 0 0 1-.55-.2.798.798 0 0 1-.2-.55.71.71 0 0 1 .2-.525.748.748 0 0 1 .55-.225h9.675c.217 0 .392.075.525.225.15.133.225.308.225.525 0 .217-.075.4-.225.55a.71.71 0 0 1-.525.2H7.15ZM4.25 8a.798.798 0 0 1-.55-.2.798.798 0 0 1-.2-.55.71.71 0 0 1 .2-.525.748.748 0 0 1 .55-.225h15.5c.217 0 .392.075.525.225.15.133.225.308.225.525 0 .217-.075.4-.225.55a.71.71 0 0 1-.525.2H4.25Z" />
    </svg>
  );
};
